import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../common-styles.css';
import './ArtisanDetailPage.css';
import GradientHero from '../shared/GradientHero';

const ArtisanDetailPage: React.FC = () => {
  return (
    <div className="artisan-detail-page">
      <GradientHero
        title={<><span>Powered by Precision.</span><br/>Perfected by Artisans.</>}
        backTo="/"
        badgeText="ARTISANS"
        subtitleHighlight="Precision"
        subtitleRest=" Perfected"
        lead={<>At SunDiam, every diamond begins its journey in the skilled hands of our artisans. With a team of over 500 dedicated craftsmen and 100 professionals supporting operations and certified sales, we bring together human excellence and thoughtful use of technology to shape natural diamonds with unmatched care.</>}
        className="artisan-hero"
        titleClassName="artisan-primary-title"
      />

      <section className="artisan-collage-section">
        <Container>
          <Row>
            <Col>
              <h2 className="section-title artisan-collage-title"><span className="section-title-highlight">Beyond Beauty</span>: Our Diamonds</h2>
            </Col>
          </Row>

          {/* First collage */}
          <Row className="artisan-collage-wrapper first">
            <Col md={12}>
              <div className="collage-grid">
                <div className="collage-left">
                  <img src={require('../../assets/images/artisan/details/1-1.png')} alt="Artisan working" />
                </div>
                <div className="collage-right-top">
                  <img src={require('../../assets/images/artisan/details/1-2.png')} alt="Workshop overview" />
                </div>
                <div className="collage-right-bottom">
                  <div className="bottom-img">
                    <img src={require('../../assets/images/artisan/details/1-3.png')} alt="Precision process" />
                  </div>
                  <div className="bottom-img">
                    <img src={require('../../assets/images/artisan/details/1-4.png')} alt="Artisan at instrument" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="artisan-collage-text text-center">
                We may not be the largest in scale—but we are focused, agile, and deeply committed to quality. Each SunDiam diamond is cut, polished, and graded in-house, ensuring consistency and control at every step. Our artisans are not just workers; they are creators—each one trained and experienced in bringing out the true brilliance of every stone.
              </p>
            </Col>
          </Row>

          {/* Second collage */}
          <Row className="artisan-collage-wrapper second">
            <Col md={12}>
              <div className="collage-grid">
                <div className="collage-left">
                  <img src={require('../../assets/images/artisan/details/2-1.png')} alt="Machinery close-up" />
                </div>
                <div className="collage-right-top">
                  <img src={require('../../assets/images/artisan/details/2-2.png')} alt="Production floor" />
                </div>
                <div className="collage-right-bottom">
                  <div className="bottom-img">
                    <img src={require('../../assets/images/artisan/details/2-3.png')} alt="Monitoring systems" />
                  </div>
                  <div className="bottom-img">
                    <img src={require('../../assets/images/artisan/details/2-4.png')} alt="Technical inspection" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="artisan-collage-text text-center">
                Behind the scenes, our efficient digital systems allow our clients around the world to experience real-time updates, transparency, and seamless service. Our Surat-based facility, though modest in size, is built for purpose, precision, and professionalism.
              </p>
              <p className="artisan-collage-text text-center mb-0">
                At SunDiam, technology empowers us, but craftsmanship defines us. Because we believe diamonds aren't just made—they are masterfully brought to life.
              </p>
              <div className="text-center mt-4">
                <Link to="/" className="back-link-inline">&larr; Back to Home</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ArtisanDetailPage;
